var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.lang === "ru"
    ? _c(
        "svg",
        {
          attrs: {
            viewBox: "0 0 705 713",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("g", { attrs: { id: "Group 782" } }, [
            _c("g", { attrs: { id: "employees" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009",
                  x: "357",
                  width: "348",
                  height: "352",
                  fill: "#F7F7F9",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "3",
                    fill: "#0B2C62",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "497.491", y: "126.221" } }, [
                    _vm._v("3. Развитие"),
                  ]),
                  _c("tspan", { attrs: { x: "497.491", y: "157.221" } }, [
                    _vm._v("сотрудников"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "principles" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009_2",
                  width: "348",
                  height: "352",
                  fill: "#F7F7F9",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "2",
                    fill: "#0B2C62",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "82.082", y: "126.221" } }, [
                    _vm._v("2. Принципы"),
                  ]),
                  _c("tspan", { attrs: { x: "78.1074", y: "157.221" } }, [
                    _vm._v("«Распадской»"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "management" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009_3",
                  y: "361",
                  width: "348",
                  height: "352",
                  fill: "#F7F7F9",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "4",
                    fill: "#0B2C62",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "78.0303", y: "561.221" } }, [
                    _vm._v("4. Эффективное"),
                  ]),
                  _c("tspan", { attrs: { x: "78.0303", y: "592.221" } }, [
                    _vm._v("управление"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "processes" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009_4",
                  x: "357",
                  y: "361",
                  width: "348",
                  height: "352",
                  fill: "#F7F7F9",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "5",
                    fill: "#0B2C62",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "407.324", y: "561.221" } }, [
                    _vm._v("5. Совершенствование"),
                  ]),
                  _c("tspan", { attrs: { x: "407.324", y: "592.221" } }, [
                    _vm._v("процессов"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "center" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009_5",
                  x: "353",
                  y: "180",
                  width: "250",
                  height: "250",
                  transform: "rotate(45 353 180)",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "1",
                    fill: "#2F2E34",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "268.198", y: "348.221" } }, [
                    _vm._v("1. Амбициозная"),
                  ]),
                  _c("tspan", { attrs: { x: "327.892", y: "379.221" } }, [
                    _vm._v("цель"),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      )
    : _c(
        "svg",
        {
          attrs: {
            viewBox: "0 0 705 713",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("g", { attrs: { id: "Group 782" } }, [
            _c("g", { attrs: { id: "employees" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009",
                  x: "357",
                  width: "348",
                  height: "352",
                  fill: "#F7F7F9",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "3",
                    fill: "#0B2C62",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "497.491", y: "126.221" } }, [
                    _vm._v("3. People"),
                  ]),
                  _c("tspan", { attrs: { x: "497.491", y: "157.221" } }, [
                    _vm._v("Development"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "principles" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009_2",
                  width: "348",
                  height: "352",
                  fill: "#F7F7F9",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "2",
                    fill: "#0B2C62",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "82.082", y: "126.221" } }, [
                    _vm._v("2. Principles"),
                  ]),
                  _c("tspan", { attrs: { x: "78.1074", y: "157.221" } }, [
                    _vm._v("of Raspadskaya"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "management" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009_3",
                  y: "361",
                  width: "348",
                  height: "352",
                  fill: "#F7F7F9",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "4",
                    fill: "#0B2C62",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "78.0303", y: "561.221" } }, [
                    _vm._v("4. Efficient"),
                  ]),
                  _c("tspan", { attrs: { x: "78.0303", y: "592.221" } }, [
                    _vm._v("management"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "processes" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009_4",
                  x: "357",
                  y: "361",
                  width: "348",
                  height: "352",
                  fill: "#F7F7F9",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "5",
                    fill: "#0B2C62",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "497.491", y: "561.221" } }, [
                    _vm._v("5. Process"),
                  ]),
                  _c("tspan", { attrs: { x: "497.491", y: "592.221" } }, [
                    _vm._v("improvement"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "center" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle 4009_5",
                  x: "353",
                  y: "180",
                  width: "250",
                  height: "250",
                  transform: "rotate(45 353 180)",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    id: "1",
                    fill: "#2F2E34",
                    "xml:space": "preserve",
                    "font-size": "22",
                    "letter-spacing": "0em",
                  },
                },
                [
                  _c("tspan", { attrs: { x: "290", y: "348.221" } }, [
                    _vm._v("1. Ambitious"),
                  ]),
                  _c("tspan", { attrs: { x: "320", y: "379.221" } }, [
                    _vm._v("target"),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }